import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';

import { selectPropertyAndLoanSummarySubjectPropertyData } from 'store/loanApplications/selectors';
import { selectCustomFields } from 'store/system/selectors/customFieldDefinitions.selectors';

const useCustomFieldHistoryContext = () => {
  const customFieldDefinitions = useSelector(selectCustomFields);
  const subjectPropertyData = useSelector(selectPropertyAndLoanSummarySubjectPropertyData);

  const customFieldDefinitionsById = useMemo(
    () => _.keyBy(customFieldDefinitions ?? [], 'id'),
    [customFieldDefinitions],
  );

  const subjectPropertyId = subjectPropertyData?.propertyId ?? null;

  return useMemo(
    () => ({ customFieldDefinitionsById, subjectPropertyId }),
    [customFieldDefinitionsById, subjectPropertyId],
  );
};

export default useCustomFieldHistoryContext;
